module.exports = __webpack_public_path__ + "img/box.f0c16d7e.svg";